import { render, staticRenderFns } from "./ConfirmPackagedOrder.vue?vue&type=template&id=1adb2d40&"
import script from "./ConfirmPackagedOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmPackagedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports